<template>
  <gj-popover lazy placement="bottom" :width="form.switchDiscount ? 603 : 523" v-model="visible" @show="show">
    <el-form :model="form" ref="form" class="gj-form" v-loading="loading">
      <div class="B2B-price">
        <el-form-item
          prop="businessPrice"
          label="B2B售价"
          class="B2B-price-item"
          style="width: 370px"
          :rules="{
              validator: validateBusinessPrice,
              trigger: 'blur',
            }"
        >
          <gj-input :width="inputWidth" v-model="form.businessPrice" placeholder="请输入B2B售价">
            <template slot="prepend">{{ form.currencySymbol }}</template>
          </gj-input>
        </el-form-item>
        <el-switch class="switch-discount" v-model="form.switchDiscount"> </el-switch>
        <span class="B2B-price-message"> 是否添加数量折扣 </span>
      </div>
      <div v-if="form.switchDiscount" class="num-discount">
        <el-form-item label="折扣方式">
          <el-radio-group v-model="form.quantityType">
            <el-radio label="percent">商品价格折扣比例</el-radio>
            <el-radio label="fixed">固定商品价格 </el-radio>
          </el-radio-group>
        </el-form-item>
        <div v-if="form.quantityType" class="num-discount-inner">
          <el-row class="discount-title">
            <el-col :span="7" style="font-weight:600; color:#333333"> 最小数量 </el-col>
            <el-col :span="3" style="font-weight:600;color:#333333"> {{ form.quantityType === 'percent' ? '折扣' : '商品售价' }}</el-col>
            <el-col :span="10" >
              <el-row type="flex" justify="center">
                <el-col style="font-weight:600;color:#333333" :span="10" v-if="form.quantityType === 'percent' && !isEu">
                  <p class="discount-p">商品售价</p>
                </el-col>
                <el-col style="font-weight:600;color:#333333" :span="10" v-if="form.quantityType === 'percent' && isEu">
                  <p class="discount-p">含增值税（VAT）</p>
                </el-col>
                <el-col style="font-weight:600;color:#333333" :span="10" v-if="isEu">
                  <p class="discount-p">不含增值税（VAT）</p></el-col
                >
              </el-row>
            </el-col>
          </el-row>
          <el-form-item
            v-for="(item, index) of form.quantityPriceList"
            :key="item.index"
            :prop="'quantityPriceList.' + index + '.price'"
            :rules="{
              validator: validatePassQuantityPrice,
              trigger: 'blur',
            }"
            label-width="0"
            width="200px"
            :class="[
              'item-my',
              index === form.quantityPriceList.length - 1 ? 'no-border-bottom' : '',
            ]"
          >
            <el-row>
              <el-col :span="7">
                <gj-input
                  width="130px"
                  v-model="item.quantity"
                >
                </gj-input>
              </el-col>
              <el-col :span="3">
                <gj-input
                  placeholder=""
                  width="90px"
                  v-model="item.price"
                  :clearable="false"
                >
                  <template slot="append">
                    {{ form.quantityType === 'percent' ? '%' : form.currencySymbol }}</template
                  >
                </gj-input>
              </el-col>
              <el-col :span="10">
                <el-row type="flex" justify="center">
                  <el-col :span="10" v-if="form.quantityType === 'percent' && !isEu">
                    <p class="discount-p">
                      {{ form.currencySymbol
                      }}{{
                        (
                          ((form.businessPrice ? form.businessPrice : form.yourPrice) *
                            (100 - item.price)) /
                          100
                        ).toFixed(preciseNum)
                      }}
                    </p>
                  </el-col>
                  <el-col :span="10" v-if="isEu && form.quantityType !== 'percent'"
                    ><p class="discount-p">
                      {{ form.currencySymbol
                      }}{{
                        (item.price / (1 + +form.sellVatRateMap[form.countryCode] / 100)).toFixed(
                          preciseNum,
                        )
                      }}
                    </p></el-col
                  >
                  <el-col :span="10" v-if="isEu && form.quantityType == 'percent'"
                    ><p class="discount-p">
                      {{ form.currencySymbol
                      }}{{
                        (form.businessPrice
                          ? (form.businessPrice * (100 - item.price)) / 100
                          : (form.yourPrice * (100 - item.price)) / 100
                        ).toFixed(preciseNum)
                      }}
                    </p></el-col
                  >
                  <el-col :span="10" v-if="isEu && form.quantityType === 'percent'"
                    ><p class="discount-p">
                      {{ form.currencySymbol
                      }}{{
                        (
                          ((form.businessPrice ? form.businessPrice : form.yourPrice) *
                            (100 - item.price)) /
                          100 /
                          (1 + +form.sellVatRateMap[form.countryCode] / 100)
                        ).toFixed(preciseNum)
                      }}
                    </p></el-col
                  >
                </el-row>
              </el-col>

              <el-col :span="4" class="B2B-icon">
                <i
                  class="el-icon-circle-plus-outline"
                  style="cursor: pointer;margin-right: 17px;"
                  @click="$addDiscount(index)"
                ></i>
                <i
                  class="el-icon-remove-outline"
                  style="cursor: pointer;"
                  @click="$deleteDiscount(index)"
                ></i>

              </el-col>
            </el-row>
          </el-form-item>
        </div>
      </div>
      <div style="text-align: right; margin: 20px 0 0 0">
        <el-button size="mini" type="text" @click="visible = false" style="border: 1px solid #1F6EEF;height:26px">取消</el-button>
        <el-button type="primary" size="mini" @click="confirm" v-loading="buttonLoading"
         style="height:26px"
          >确定</el-button
        >
      </div>
    </el-form>
    <i class="el-icon-edit" slot="reference"></i>
  </gj-popover>
</template>

<script>
import { editGoodB2bPrice } from '@/api/sale';
import { formRuleMixin } from '../../../../../minxins';

export default {
  name: 'edit-good-title',
  props: {
    row: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  mixins: [formRuleMixin],
  data() {
    return {
      preciseNum: 2,
      visible: false,
      loading: false,
      buttonLoading: false,
      isEu: '',
      form: {
        yourPrice: '',
        currencySymbol: '',
        quantityType: 'percent',
        businessPrice: '',
        switchDiscount: '',
        sellVatRateMap: '',
        quantityPriceList: [],
      },
      inputWidth: '300px',
    };
  },
  methods: {
    show() {
      this.isEu = this.row.isEu
      this.form = {
        yourPrice: this.row.yourPrice,
        currencySymbol: this.row.currencySymbol,
        quantityType: this.row.quantityType || 'percent',
        businessPrice: this.row.businessPrice,
        switchDiscount: this.row.switchDiscount,
        sellVatRateMap: this.row.sellVatRateMap,
        countryCode: this.row.countryCode,
        quantityPriceList:
          Array.isArray(this.row.quantityPriceList) && this.row.quantityPriceList.length
            ? this.row.quantityPriceList
            : [
                {
                  quantity: '',
                  price: '',
                },
                {
                  quantity: '',
                  price: '',
                },
              ],
      };
    },
    validateBusinessPrice(rule, value, callback){
      if (+this.form.businessPrice > +this.form.yourPrice) {
        callback(new Error('B2B售价不得大于原价'));
      }else{
        callback()
      }
    },
    validatePassQuantityPrice(rule, value, callback) {
      const index = rule.fullField.split('.')[1],
        quantityPrice = this.form.quantityPriceList[index];
      let flag = true;
      if (!(quantityPrice.quantity && quantityPrice.price)) {
        flag = false;
        callback(new Error('请输入数量和折扣值'));
      } else if (!this.RE.pt0.test(quantityPrice.quantity)) {
        flag = false;
        callback(new Error('数量必须为正整数'));
      } else if (
        this.form.quantityType === 'percent' &&
        (quantityPrice.price >= 100 || quantityPrice.price <= 0)
      ) {
        flag = false;
        callback(new Error('只能填0到100之间的数字，不包括0到100'));
      } else if (
        this.form.quantityType === 'percent' &&
        !/^(([1-9]{1}\d*)|(0{1}))(\.\d{1,3})?$/.test(quantityPrice.price)
      ) {
        flag = false;
        callback(new Error('折扣值不得超过三位小数'));
      } else {
        for (let i = 0; i < this.form.quantityPriceList.length; i++) {
          if (
            i == index ||
            !this.form.quantityPriceList[i].quantity ||
            !this.form.quantityPriceList[i].price
          )
            continue;
          if (quantityPrice.quantity === this.form.quantityPriceList[i].quantity) {
            flag = false;
            callback(new Error('数量值不得相同'));
            break;
          }
          if (+quantityPrice.quantity > +this.form.quantityPriceList[i].quantity) {
            if (this.form.quantityType === 'percent') {
              if (+quantityPrice.price <= +this.form.quantityPriceList[i].price) {
                flag = false;
                callback(new Error('数量越多，折扣值越大'));
                break;
              }
            } else {
              if (+quantityPrice.price >= +this.form.quantityPriceList[i].price) {
                flag = false;
                callback(new Error('数量越多，优惠价越低'));
                break;
              }
            }
          }
        }
      }
      if (flag) callback();
    },
    $deleteDiscount(index) {
      if (this.form.quantityPriceList.length <= 1) {
        this.$gjMessage.warning('最少需留一条数据');
        return;
      }
      this.form.quantityPriceList.splice(index, 1);
    },
    $addDiscount(index) {
      if (this.form.quantityPriceList.length >= 5) {
        this.$gjMessage.warning('最多只可添加5条');
        return;
      }
      this.form.quantityPriceList.splice(index + 1, 0, {
        quantity: '',
        price: '',
      });
    },
    confirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.buttonLoading = true;
          const params = {
            ...this.form,
            listingId: this.row.id,
          };
          params.quantityPriceList = this.form.switchDiscount ? params.quantityPriceList : []
          editGoodB2bPrice(params)
            .then(() => {
              this.visible = false;
            })
            .complete(() => (this.buttonLoading = false));
        }
      });
    },
  },
};
</script>
<style scoped lang="scss">
.gj-form {
   /deep/ .el-radio__label{
    color: #333333 !important;
    font-weight: 400 !important;
  }
}
.num-discount {
  margin-top: 10px;
  margin-bottom: 20px;
}
.num-discount-inner {
  width: 600px;
  background: #ffffff;
  border: 1px solid #e4e5e6;
  box-sizing: border-box;
  border-radius: 2px;
}
.discount-title {
  padding: 10px 0px 10px 10px;
  background: #f6f8fb;
  border-radius: 2px 2px 0px 0px;
  border-bottom: 1px solid #e4e5e6;
}
.item-my {
  padding: 16px 0 16px 10px;
  border-bottom: 1px solid #e4e5e6;
  margin-bottom: 0;
  /deep/.el-row {
    border: none;
  }
}
.no-border-bottom {
  border-bottom: 0px solid #e4e5e6 !important;
}
.discount-p {
  text-align: left;
  margin: 0;
}
.from-title {
  font-weight: bold;
  font-size: 12px;
  padding-left: 6px;
  border-left: 4px solid #1f6eef;
  margin-bottom: 20px;
}
.setting-icon {
  font-size: 16px;
  margin-left: 4px;
  display: none;
  cursor: pointer;
}
.setting-wrapper:hover .setting-icon {
  display: inline;
  line-height: 1;
}
.B2B-price {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.B2B-price-item {
  margin: 0;
}
.B2B-price-message {
  font-size: 12px;
  margin-left: 5px;
  white-space: nowrap;
}
.B2B-icon {
  font-size: 20px;
  text-align: center;
}
.switch-discount {
  margin-left: 8px;
}
</style>
